module.exports = __webpack_public_path__ + "static/media/bat.a5ba2330.svg";